// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable */
.Radio_container__SubyA {
  display: flex;
  gap: 10px;
  position: relative;
  color: var(--font-primary-color);
  padding-left: 26px;
  margin-right: 16px;
  cursor: pointer;
}

.Radio_field__AtEWR {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  padding: 10px;
  flex-wrap: wrap;
}

.Radio_radioOption__Cn-VS {
  margin-bottom: 0;
  margin-right: 16px;
  display: flex;
  align-items: center;
}

input[type=radio] {
  outline: 0;
  opacity: 0;
  margin: 0;
  position: absolute;
  left: 0;
  width: 1px;
  height: 1px;
  overflow: hidden;
}
input[type=radio]:checked + .Radio_container__SubyA .Radio_label__K8QgH::after {
  content: "";
  position: absolute;
  left: -22px;
  top: 4px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--accent-color);
}

.Radio_label__K8QgH {
  display: inline-block;
  position: relative;
}
.Radio_label__K8QgH::before {
  content: "";
  position: absolute;
  left: -26px;
  width: 18px;
  height: 18px;
  background: white;
  border: 1px solid var(--font-primary-color);
  border-radius: 50%;
  cursor: pointer;
  transition: background 0.3s;
  top: 0;
}`, "",{"version":3,"sources":["webpack://./src/_common/components/Radio/Radio.module.scss","webpack://./src/_common/scss/_colors.scss","webpack://./src/_common/scss/_variables.scss"],"names":[],"mappings":"AAAA,sBAAA;AAIA;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,gCCLa;EDMb,kBAAA;EACA,kBAAA;EACA,eAAA;AAFF;;AAKA;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,aEfU;EFgBV,eAAA;AAFF;;AAKA;EACE,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAFF;;AAKA;EACE,UAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;AAFF;AAOQ;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,+BClDD;AD6CT;;AAYA;EACE,qBAAA;EACA,kBAAA;AATF;AAWE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,2CAAA;EACA,kBAAA;EACA,eAAA;EACA,2BAAA;EACA,MAAA;AATJ","sourcesContent":["/* stylelint-disable */\n@import '@common/scss/_colors';\n@import '@common/scss/_variables';\n\n.container {\n  display: flex;\n  gap: 10px;\n  position: relative;\n  color: $font-primary;\n  padding-left: 26px;\n  margin-right: 16px;\n  cursor: pointer;\n}\n\n.field {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  padding: $padding-m;\n  flex-wrap: wrap;\n}\n\n.radioOption {\n  margin-bottom: 0;\n  margin-right: 16px;\n  display: flex;\n  align-items: center;\n}\n\ninput[type='radio'] {\n  outline: 0;\n  opacity: 0;\n  margin: 0;\n  position: absolute;\n  left: 0;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n\n  &:checked {\n    + .container {\n      .label {\n        &::after {\n          content: '';\n          position: absolute;\n          left: -22px;\n          top: 4px;\n          width: 10px;\n          height: 10px;\n          border-radius: 50%;\n          background: $accent;\n        }\n      }\n    }\n  }\n}\n\n.label {\n  display: inline-block;\n  position: relative;\n\n  &::before {\n    content: '';\n    position: absolute;\n    left: -26px;\n    width: 18px;\n    height: 18px;\n    background: white;\n    border: 1px solid $font-primary;\n    border-radius: 50%;\n    cursor: pointer;\n    transition: background 0.3s;\n    top: 0;\n  }\n}","$primary: var(--primary-color);\n$secondary: var(--secondary-color);\n$accent: var(--accent-color);\n$font-primary: var(--font-primary-color);\n$font-secondary: var(--font-secondary-color);\n$font-accent: var(--font-accent-color);\n$grey-100: #f4f5f7;\n$grey-200: #dbdbdb;\n$grey-300: #acacac;\n$grey-400: #838383;\n$chart-dataset-1: #df6767;\n$chart-dataset-2: #efa12c;\n$warning: orange;\n$error: #df6767;\n$white: #fff;\n$transparent: transparent;\n\n$primary-font-color: #fff;\n$secondary-font-color: #fff;\n$accent-font-color: #fff;\n$warning-font-color: #fff;\n$error-font-color: #fff;\n$filter-bg: #fff;\n\n$bg-main: var(--background-color);\n$card-bg: #fff;\n$default-control-bg: #fff;\n$card-shadow: 3px 3px 3px -1px rgba(0, 0, 0, 0.1);\n$default-shadow-color: rgba(0, 0, 0, 0.1);\n\n$default-border-color: #acacac;\n$default-backdrop-color: rgba(0, 0, 0, 0.8);\n\n$default-navbar-color: #fff;\n\n$stats-card-bg-color: #fff;\n$stats-card-color: #000;\n","@import './colors';\n\n$border-radius: 3px !default;\n$border-radius-extra: 8px !default;\n$padding-s: 5px;\n$padding-m: 10px;\n$padding-l: 20px;\n$padding-xl: 30px;\n$padding-xxl: 40px;\n$margin-s: 5px;\n$margin-m: 10px;\n$margin-l: 20px;\n$margin-xl: 30px;\n$margin-xxl: 40px;\n$margin-xxxl: 50px;\n$shadow-depth: 1;\n$base-font-size: 14px !default;\n$base-line-height: 17px !default;\n$base-unit: 'em' !default;\n$base-font-family: 'Source Sans Pro', sans-serif !default;\n$h1-font-size: 2 * $base-font-size !default;\n$h2-font-size: 1.5 * $base-font-size !default;\n$h3-font-size: 1.17 * $base-font-size !default;\n$h4-font-size: 1 * $base-font-size !default;\n$h5-font-size: 0.83 * $base-font-size !default;\n$h6-font-size: 0.67 * $base-font-size !default;\n$indent-amount: 40px !default;\n$normalize-vertical-rhythm: false !default;\n$default-border: solid 1px $default-border-color;\n$navbar-z-index: 10000;\n$top-most-z-index: 100000;\n$navbar-height: 67px;\n$navbar-bg: #d9d9d9;\n$default-navbar-shadow: 0 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-statscard-shadow: 3px 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-mainfilters-shadow: inset -3px 0 3px rgb(0 0 0 / 0.1);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Radio_container__SubyA`,
	"field": `Radio_field__AtEWR`,
	"radioOption": `Radio_radioOption__Cn-VS`,
	"label": `Radio_label__K8QgH`
};
export default ___CSS_LOADER_EXPORT___;
